import { Button } from '@journ/ui/button'
import { Icons } from '@journ/ui/icons'
import { Sheet, SheetContent, SheetHeader } from '@journ/ui/sheet'
import { useIntlayer } from 'react-intlayer'
import { GLOBAL_SHEET_IDS, useSheet } from '@/features/ui/hooks/use-sheet'
import { useMemberActions } from '../hooks/use-member-actions'
import { refreshMembersList } from '../store'
import { MemberForm } from './member-form'
import type { FormValues } from './member-form'

const MemberCreateSheet = () => {
	const content = useIntlayer('hr-page')
	const { isOpen, close } = useSheet(GLOBAL_SHEET_IDS.MEMBER_CREATE)
	const { saveMember } = useMemberActions()

	const handleSubmit = async (values: FormValues): Promise<void> => {
		await saveMember({
			fullName: values.fullName,
			email: values.email,
			employmentType: values.employmentType ?? 'full_time',
			status: values.status ?? 'active',
			preferredName: values.preferredName ?? null,
			personalEmail: values.personalEmail ?? null,
			workPhone: values.workPhone ?? null,
			personalPhone: values.personalPhone ?? null,
			position: values.position ?? null,
			departmentId: values.departmentId ?? null,
			teamIds: [],
			managerId: null,
			startDate: values.startDate ?? null,
			location: values.location ?? null,
			timezone: values.timezone ?? null,
			addressLine1: values.addressLine1 ?? null,
			addressLine2: values.addressLine2 ?? null,
			city: values.city ?? null,
			state: values.state ?? null,
			countryCode: values.countryCode ?? null,
			zip: values.zip ?? null,
			defaultWorkSchedule: values.defaultWorkSchedule ?? null,
		})
		refreshMembersList()
		close()
	}

	return (
		<Sheet open={isOpen} onOpenChange={close}>
			<SheetContent stack title={content.createSheet.title.value}>
				<SheetHeader className='mb-6 flex justify-between items-center flex-row'>
					<h2 className='text-xl'>{content.createSheet.title}</h2>
					<Button size='icon' variant='ghost' onClick={close} className='p-0 m-0 size-auto hover:bg-transparent'>
						<Icons.Close className='size-5' />
					</Button>
				</SheetHeader>
				<MemberForm onSubmit={handleSubmit} onCancel={close} />
			</SheetContent>
		</Sheet>
	)
}

export { MemberCreateSheet }
